import * as CommunityConstants from "../constants/community.constant";
import { Loading } from "../utils/helpers/constants";
import { modifyList } from "../utils/helpers/dataHelper";

const initialState = {
  communities: [],
  community: {},
  communityLoading: "",
  communityListLoading: "",
  joinCommunityLoading: "",
  communityStatusLoading: false,
  creator: {},
  modal: false,
  membersLoading: "",
  communityMembers: [],
  userMember: false,
};

const setLoading = (state, action) => {
  const actionLoading = { ...state.communityStatusLoading };
  const { loading, id } = action.payload;
  actionLoading[id] = loading;
  return actionLoading;
};

const communityReducer = (state = initialState, action) => {
  switch (action.type) {
    case CommunityConstants.FETCH_ALL_COMMUNITY_REQUEST:
      return { ...state, communityListLoading: Loading.FETCHING };
    case CommunityConstants.FETCH_ALL_COMMUNITY_SUCCESS:
      return {
        ...state,
        communities: action.payload,
        communityListLoading: Loading.SUCCESS,
      };
    case CommunityConstants.FETCH_ALL_COMMUNITY_FAILURE:
      return { ...state, communityListLoading: Loading.FAILED };

    case CommunityConstants.FETCH_COMMUNITY_MEMBERS_REQUEST:
      return { ...state, membersLoading: Loading.FETCHING };
    case CommunityConstants.FETCH_COMMUNITY_MEMBERS_SUCCESS:
      return {
        ...state,
        membersLoading: Loading.SUCCESS,
        communityMembers: action.payload.students,
      };
    case CommunityConstants.FETCH_COMMUNITY_MEMBERS_FAILURE:
      return { ...state, membersLoading: Loading.FAILED };

    case CommunityConstants.FETCH_COMMUNITY_REQUEST:
      return { ...state, communityLoading: Loading.FETCHING };
    case CommunityConstants.FETCH_COMMUNITY_SUCCESS:
      return {
        ...state,
        community: action.payload,
        creator: action.payload.creator,
        communityLoading: Loading.SUCCESS,
        userMember: action.payload.userMember,
      };
    case CommunityConstants.FETCH_COMMUNITY_FAILURE:
      return { ...state, communityLoading: Loading.FAILED };

    case CommunityConstants.JOIN_COMMUNITY_REQUEST:
      return { ...state, joinCommunityLoading: Loading.FETCHING };
    case CommunityConstants.JOIN_COMMUNITY_SUCCESS:
      return {
        ...state,
        joinCommunityLoading: Loading.SUCCESS,
        userMember: true,
      };
    case CommunityConstants.JOIN_COMMUNITY_FAILURE:
      return { ...state, joinCommunityLoading: Loading.FAILED };

    case CommunityConstants.LEAVE_COMMUNITY_REQUEST:
      return { ...state, joinCommunityLoading: Loading.FETCHING };
    case CommunityConstants.LEAVE_COMMUNITY_SUCCESS:
      return {
        ...state,
        joinCommunityLoading: Loading.SUCCESS,
        userMember: false,
      };
    case CommunityConstants.LEAVE_COMMUNITY_FAILURE:
      return { ...state, joinCommunityLoading: Loading.FAILED };

    case CommunityConstants.CREATE_COMMUNITY_REQUEST:
      return { ...state, communityLoading: Loading.FETCHING };
    case CommunityConstants.CREATE_COMMUNITY_SUCCESS:
      return {
        ...state,
        communityLoading: Loading.SUCCESS,
        modal: true,
      };
    case CommunityConstants.CREATE_COMMUNITY_FAILURE:
      return { ...state, communityLoading: Loading.FAILED };

    case CommunityConstants.COMMUNITY_APPROVAL_REQUEST:
      return {
        ...state,
        communityStatusLoading: setLoading(state, action),
      };
    case CommunityConstants.COMMUNITY_APPROVAL_SUCCESS:
      const communityList = [...state.communities];
      const modifiedList = modifyList(
        communityList,
        action.payload.id,
        "id",
        "approved"
      );
      return {
        ...state,
        communities: modifiedList,
        communityStatusLoading: setLoading(state, action),
      };
    case CommunityConstants.COMMUNITY_APPROVAL_FAILURE:
      return { ...state, communityStatusLoading: setLoading(state, action) };
    case CommunityConstants.CLOSE_COMMUNITY_MODAL_REQUEST:
      return {
        ...state,
        modal: false,
      };

    default:
      return state;
  }
};

export default communityReducer;
